const l = "_overlay_1w02d_1", e = "_fullSize_1w02d_8", o = {
  overlay: l,
  fullSize: e
};
export {
  o as default,
  e as fullSize,
  l as overlay
};
//# sourceMappingURL=index.es5610.js.map
